import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { UsersService } from './users.service';
import { ConfigService } from './config.service';
import { CookieService } from 'ngx-cookie';

@Injectable()
export class AuthGuard  {
	constructor (
		private authService: AuthService,
		private router: Router,
		private usersService: UsersService,
		private configService: ConfigService,
		private _cookieService: CookieService ) {}

	canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) {
		console.log('AuthGuard#canActivate called');
		console.log(this.configService.checkIfGuestAllowed(), route.data.permission);
		const username = this._cookieService.get('NOIUserName');
		const password = this._cookieService.get('NOIUserPassword');

		// if guests are allowed to roam free and there is no special permission attached to this, return true
		if ( this.configService.checkIfGuestAllowed() && route.data.permission === undefined ) {
			console.log( 'Allowing because guests are allowed in this system.');
			return true;
		}

		//
		// If logged in, return if user has permissions
		if ( this.authService.isLoggedIn ) {
			console.log('user already logged in');
			this.usersService.hasPermission(username, route.data.permission).subscribe((data) => {
				if ( data === false ) {
					alert('User ' + username + ' does not have the required permission ' + route.data.permission + ' to access');
				} else {
					console.log( data );
				}
			});
			return this.usersService.hasPermission(username, route.data.permission);
		}

		//
		// Not logged in but have cookies.
		// Login with cookies.
		//     If successful, read user configuration and go to /map.
		//     Otherwise, send user to login page.
		//
		if ( username !== 'undefined' ) {
			this.configService.setUserName( username, password )
			.subscribe((data) => {
				console.log(data);
				if ( data.status === 'success' ) {
					this.authService.loginSuccessful ( username, password );
					this.authService.saveAuthorization ( data.Authorization );
				}
				console.log('cookie detected.  user: ' + this._cookieService.get('NOIUserName'));
				console.log('authService.isLoggedIn set to: ' + this.authService.isLoggedIn);
				if (this.authService.isLoggedIn) {
					// Get the redirect URL from our auth service
					// If no redirect has been set, use the default
					this.configService.setupUser();
					const redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '/map';
					// Redirect the user
					console.log(redirect);
					this.router.navigate([redirect]);
				}
			});
		}

		// store the attempted URL for redirecting
		console.log(state.url);
		this.authService.setRedirect ( state.url );

		if ( this.authService.isLoggedIn === false )	{
			// navigate to the login page
			console.log('Navigating to login');
			this.router.navigate(['/login']);
			return false;
		}
		this.usersService.hasPermission(username, route.data.permission).subscribe((data) => {
			if ( data === false ) {
				alert('User ' + username + ' does not have the required permission ' + route.data.permission + ' to access');
			}
		});
		return this.usersService.hasPermission(username, route.data.permission);
	}

}
